export const AUTH_SCOPED_STATE_RESET_EVENT = 'dobi:auth-scoped-state-reset';
let authScopeRevision = 0;

export function getAuthScopeRevision(): number { return authScopeRevision; }

export function requestAuthScopedStateReset(): void {
  authScopeRevision += 1;
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(AUTH_SCOPED_STATE_RESET_EVENT));
}

/** Register module caches once across development reloads, without importing their stores. */
export function registerAuthScopedCacheReset(name: string, reset: () => void): void {
  if (typeof window === 'undefined') return;
  const host = globalThis as typeof globalThis & { __dobiAuthCacheResets?: Map<string, () => void> };
  if (!host.__dobiAuthCacheResets) {
    host.__dobiAuthCacheResets = new Map();
    window.addEventListener(AUTH_SCOPED_STATE_RESET_EVENT, () => {
      for (const clear of host.__dobiAuthCacheResets!.values()) clear();
    });
  }
  host.__dobiAuthCacheResets.set(name, reset);
}
